import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import './double-banner.scss';
import { headerHeight } from '../../scripts/helpers';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initDoubleBanner = (context) => {
  const doubleBannerSection = context.closest('.shopify-section');
  if (!doubleBannerSection) return;
  gsap.registerPlugin(ScrollTrigger);

  const carouselContainer = doubleBannerSection.querySelector('.double-banner-carousel__slides-container');
  if (carouselContainer) {
    new Swiper(carouselContainer, {
      loop: false,
      freeMode: true,
      mousewheel: true,
      slidesPerView: 'auto'
    });
  }

  const verticalLine = doubleBannerSection.querySelector('.double-banner__middle-line');
  if (verticalLine) {
    gsap.to(verticalLine, {
      height: '100%',
      scrollTrigger: {
        ease: 'elastic.out(1, 0.3)',
        trigger: doubleBannerSection,
        start: `top ${headerHeight()}`,
        end: '100%',
        scrub: 3,
        markers: false
      }
    });
  }

  doubleBannerSection.querySelectorAll('.double-banner__image-text').forEach(fiftyFiftyBanner => {
    const texts = fiftyFiftyBanner.querySelector('.double-banner-image-text__texts');
    const image = fiftyFiftyBanner.querySelector('.double-banner-image-text__image');
    gsap.to(texts, {
      yPercent: -45,
      scrollTrigger: {
        ease: 'elastic.out(1, 0.3)',
        trigger: fiftyFiftyBanner,
        start: 'top bottom',
        end: '+=100%',
        scrub: 3,
        markers: false
      }
    });
    gsap.to(image, {
      yPercent: -35,
      scrollTrigger: {
        ease: 'elastic.out(1, 0.3)',
        trigger: fiftyFiftyBanner,
        start: 'top bottom',
        end: '+=100%',
        scrub: 3,
        markers: false
      }
    });
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.double-banner__container'), (el) => {
    window.dAgency.initDoubleBanner(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.double-banner__container'), (el) => {
      window.dAgency.initDoubleBanner(el);
    });
  });
}
